import { FC } from 'react';
import { Spin } from 'antd';
import { Plant } from '@pro/420CheckIn/Interactive/Plant';
import { RowLoading } from '@base/lib/ThemeLoadingV2';
import { OptionLabel } from '@pro/420CheckIn/Interactive/OptionLabel';
import { OptionCheckIn } from '@pro/420CheckIn/Interactive/OptionCheckIn';
import { OptionShare } from '@pro/420CheckIn/Interactive/OptionShare';
import { EarnedTip } from '@pro/420CheckIn/Interactive/EarnedTip';
import { useCheckInContext } from 'mod/checkIn/useCheckInContext';
import { OptionBtn } from '@pro/420CheckIn/Interactive/OptionBtn';
import { Trans, useTrans } from 'base/utils/i18n';
import { HtmlRender } from '@base/snippets/HtmlRender';

export const StatusAndOption: FC = () => {
    const { data, loading, fetchData, shareCallback, onCheckIn } = useCheckInContext();
    const { t } = useTrans();

    if (loading) {
        return <RowLoading/>;
    }

    const {
        shareBoom: {
            checkIn,
            boom
        }
    } = data;

    if (!checkIn) {
        return (
            <Spin spinning={loading}>
                <Plant src={'asset/width-640/picture/3867c397b5dcf611d2fee1993ec95ac6.png'}/>
                <OptionLabel code={'web_checkin_plant_check_in'}/>
                <OptionCheckIn onCheckIn={onCheckIn}/>
            </Spin>
        )
    }
    if (!boom) {
        return (
            <Spin spinning={loading}>
                <Plant src={'asset/width-640/picture/698666240c7c5d1e7dfa582fbabc03dd.png'}/>
                <OptionLabel code={'web_checkin_plant_share'}/>
                <OptionShare
                    data={data}
                    fetchData={fetchData}
                    shareCallback={shareCallback}
                />
                <EarnedTip data={data}/>
            </Spin>
        )
    }

    return (
        <>
            <Plant src={'asset/width-640/picture/b69954de1dce5e10069950a5e4b265f2.png'}/>
            <OptionLabel code={'web_checkin_plant_done'}/>
            <OptionBtn disabled>
                <HtmlRender html={t('web_checkin_btn_congrats')}/>
            </OptionBtn>
            <EarnedTip data={data}/>
        </>
    )
};
